import axios from "axios";
import {
  startCreateAppointment,
  successCreateAppointment,
  errorCreateAppointment,
} from "../../slice/Appointment";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const createCounsellorAppointment = (appointmentData) => {
  return async (dispatch) => {
    dispatch(startCreateAppointment());
    const config = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
    };
    try {
      const response = await axios.post(
        `${API_BASE_URL}/appointment/counsellor-create`,
        appointmentData,
        config
      );
      dispatch(successCreateAppointment(response.data));
      return response.data;
    } catch (error) {
      dispatch(errorCreateAppointment(error.message));
      throw error;
    }
  };
};
